// extracted by mini-css-extract-plugin
export default {"title":"article_title__QUkoY","picture":"article_picture__XE4Pg","blocpicture":"article_blocpicture__knlh7"};